export default __webpack_public_path__ + "static/media/ez_logo.a1c5a1f4.jpg";